import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Subject } from 'rxjs';

import { EAssemblyOrderStatus, EAssemblyOrderType } from '../../interfaces';

interface IAssemblyOrderActionCellRendererParams extends ICellRendererParams {
  onExportOrder :(data :any) => void;
  onDeleteOrder :(data :any) => void;
}

@Component({
  selector: 'lum-assembly-order-action-cell-renderer',
  templateUrl: './assembly-order-action-cell-renderer.component.html',
  styleUrls: ['./assembly-order-action-cell-renderer.component.scss'],
})
export class AssemblyOrderActionCellRendererComponent
  implements ICellRendererAngularComp, OnDestroy
{
  params :IAssemblyOrderActionCellRendererParams;
  private onDestroy$ = new Subject<void>();
  orderStatus = EAssemblyOrderStatus;
  loading :boolean = false;
  orderTooltip :string = 'Assembly Order';

  constructor(private router :Router) {}

  agInit(params :IAssemblyOrderActionCellRendererParams) :void {
    this.params = params;
    if (this.params.data.type === EAssemblyOrderType.DISASSEMBLY) {
      this.orderTooltip = 'Disassembly Order';
    }
  }

  refresh(params :IAssemblyOrderActionCellRendererParams) :boolean {
    return false;
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onUpdateOrderEvent() :void {
    if (this.params.data.type === EAssemblyOrderType.DISASSEMBLY) {
      this.router.navigate([
        'assembly-orders/disassembly',
        this.params.data.id,
        'edit',
      ]);

      return;
    }

    this.router.navigate(['assembly-orders', this.params.data.id, 'edit']);
  }

  onExportOrderEvent() :void {
    this.params.onExportOrder(this.params.data);
  }

  onDeleteOrderEvent() :void {
    this.params.onDeleteOrder(this.params.data);
  }
}
